import CartStore from './cartStoreMixins'
import CustomerStore from './customerStoreMixins'
import PricingStore from './pricingStoreMixins'
import CatalogStore from './catalogStoreMixins'
import GlobalStore from './globalStoreMixins'

export default {
    mixins: [
        CartStore,
        CustomerStore,
        PricingStore,
        CatalogStore,
        GlobalStore,
    ]
}